import React from "react";

export default ({msg}) => (
  <div className="notice notice__warning">
    <span>{msg}</span>
  </div>
)
